import { useEffect, useRef } from 'react'
import { useUser, useAuth } from '@clerk/clerk-react'
import { useAuthStore } from '../../stores/authStore'
import logger from '../../utils/logger'

/**
 * Komponent synchronizujący stan Clerk z Zustand authStore.
 * Musi być umieszczony wewnątrz ClerkProvider.
 * Nie renderuje żadnego UI.
 */
export function ClerkAuthSync() {
  const { user: clerkUser, isLoaded: clerkLoaded } = useUser()
  const { isSignedIn } = useAuth()
  const { setUser, setLoading, setInitialized, signOut } = useAuthStore()
  const prevUserIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (!clerkLoaded) {
      setLoading(true)
      return
    }

    if (isSignedIn && clerkUser) {
      const userId = clerkUser.id
      const email = clerkUser.primaryEmailAddress?.emailAddress ?? ''

      // Aktualizuj store tylko jeśli user się zmienił
      if (prevUserIdRef.current !== userId) {
        logger.debug('ClerkAuthSync: User signed in', email)
        setUser({ id: userId, email })
        prevUserIdRef.current = userId
      }
    } else {
      // User wylogowany
      if (prevUserIdRef.current !== null) {
        logger.debug('ClerkAuthSync: User signed out')
        prevUserIdRef.current = null
        // Wykonaj lokalny cleanup
        signOut().catch((e) => {
          logger.error('ClerkAuthSync: signOut cleanup error', e)
        })
      } else {
        setUser(null)
      }
    }

    setLoading(false)
    setInitialized(true)
  }, [clerkLoaded, isSignedIn, clerkUser, setUser, setLoading, setInitialized, signOut])

  return null
}
